(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bk-collection-pills"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bk-collection-pills')) {
    customElements.define('bk-collection-pills', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.setup(); });
      }
      setup() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.cleanup?.();
        const viewport = this.querySelector('.bk-pills__viewport');
        const list = this.querySelector('.bk-pills__list');
        const frame = this.querySelector('.bk-pills__frame');
        const previous = this.querySelector('.bk-pills__arrow--previous');
        const next = this.querySelector('.bk-pills__arrow--next');
        if (!viewport || !list || !frame || !previous || !next) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const mobile = window.matchMedia('(max-width: 699px)');
        let drag = null;
        let blockClickUntil = 0;
        let animationFrame = 0;
        const direction = () => getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        const update = () => {
          animationFrame = 0;
          const maximum = viewport.scrollWidth - viewport.clientWidth;
          const position = Math.abs(viewport.scrollLeft);
          const canPrevious = position > 2;
          const canNext = position < maximum - 2;
          const showArrows = !mobile.matches && maximum > 1;
          previous.disabled = !canPrevious;
          next.disabled = !canNext;
          previous.hidden = !showArrows || !canPrevious;
          next.hidden = !showArrows || !canNext;
          frame.dataset.canPrevious = String(showArrows && canPrevious);
          frame.dataset.canNext = String(showArrows && canNext);
          viewport.tabIndex = maximum > 1 ? 0 : -1;
        };
        const scheduleUpdate = () => {
          if (!animationFrame) animationFrame = requestAnimationFrame(update);
        };
        const finish = () => {
          if (drag?.active) blockClickUntil = performance.now() + 400;
          drag = null;
          viewport.classList.remove('is-dragging');
        };
        const scroll = (step) => viewport.scrollBy({
          left: step * direction() * viewport.clientWidth * .75,
          behavior: reducedMotion.matches ? 'instant' : 'smooth'
        });
        previous.addEventListener('click', () => scroll(-1), options);
        next.addEventListener('click', () => scroll(1), options);
        viewport.addEventListener('scroll', scheduleUpdate, { ...options, passive: true });
        viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          if (viewport.scrollWidth <= viewport.clientWidth + 1) return;
          blockClickUntil = 0;
          drag = { id: event.pointerId, x: event.clientX, left: viewport.scrollLeft, active: false };
        }, options);
        window.addEventListener('pointermove', (event) => {
          if (!drag || event.pointerId !== drag.id) return;
          if (event.buttons !== 1) { finish(); return; }
          const distance = event.clientX - drag.x;
          if (!drag.active && Math.abs(distance) < 6) return;
          drag.active = true;
          event.preventDefault();
          viewport.classList.add('is-dragging');
          viewport.scrollLeft = drag.left - distance;
        }, options);
        window.addEventListener('pointerup', finish, options);
        window.addEventListener('pointercancel', finish, options);
        window.addEventListener('blur', finish, options);
        viewport.addEventListener('dragstart', (event) => event.preventDefault(), options);
        viewport.addEventListener('click', (event) => {
          if (event.detail !== 0 && performance.now() < blockClickUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { ...options, capture: true });
        const reveal = (item) => {
          const itemRect = item.getBoundingClientRect();
          const viewportRect = viewport.getBoundingClientRect();
          if (itemRect.left < viewportRect.left || itemRect.right > viewportRect.right) {
            viewport.scrollBy({ left: itemRect.left - viewportRect.left - (viewportRect.width - itemRect.width) / 2, behavior: 'instant' });
          }
        };
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('.bk-pills__item');
          if (item) reveal(item);
        }, options);
        this.observer = new ResizeObserver(scheduleUpdate);
        this.observer.observe(viewport);
        this.observer.observe(frame);
        this.observer.observe(list);
        update();
        const selected = list.querySelector('[aria-current="page"]');
        if (selected) reveal(selected);
        this.cleanup = () => {
          cancelAnimationFrame(animationFrame);
          finish();
        };
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.cleanup?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
